import React from 'react'
import styles from './StageStudy.module.css'
import {
    ViewPager,
    Frame,
    Track,
    View,
} from 'react-view-pager'

import Image from '../components/Image/Image'
import {
    getSoundDownloadUrl,
} from '../components/Sound/Sound'


const StageStudy = ({
    data,
    onPageChange,
    viewPagerEl,
}) => {

    let imageCountIndex = 0;

    const onSoundClick = (word) => {
        getSoundDownloadUrl(data.word_sounds[word]).then((url) => {
            new Audio(url).play();
        })
    }

    return (
        <ViewPager
            className={styles.viewPager}>
            <Frame
                className={styles.frame}>
                <Track
                    ref={c => viewPagerEl.current = c}
                    viewsToShow={1}
                    infinite={false}
                    onViewChange={(index) => {
                        onPageChange(index[0])
                    }}
                    className={styles.track}
                >
                    {
                        data.text.map((t, i) => {
                            return (
                                <View className={styles.view}>
                                    {
                                        t.split('\\n').map((p) => {
                                            if (p === '&&') {
                                                return <Image size={'60%'} imagePath={data.images[imageCountIndex++]} />
                                            }
                                            return (
                                                <pre className={styles.content}>
                                                    {
                                                        p.split('$').map((pp, index) => {
                                                            if (index % 2 === 1) return <b>{pp}</b>
                                                            else {
                                                                return pp.split('~').map((ppp, index2) => {
                                                                    if (index2 % 2 === 1) return <span className={styles.listenText} onClick={() => onSoundClick(ppp)}>{ppp}</span>
                                                                    else return <>{ppp}</>
                                                                })
                                                            }
                                                        })
                                                    }
                                                </pre>
                                            )
                                        })
                                    }
                                    <div style={{ height: '64px' }} />
                                </View>
                            )
                        })
                    }
                </Track>
            </Frame>
        </ViewPager>
    )
}

export default StageStudy
